// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1Pbli","header":"PatientBlock_header__N23WY","label":"PatientBlock_label__2PsuG","option":"PatientBlock_option__2J0A9"};